import React from "react";
import styles from "./forminput.module.css";

function Forminput({
  header,
  id,
  type,
  maxLength = undefined,
  value = undefined,
  onChange = () => {},
  error,
}) {
  const handleChange = (evt) => {
    onChange(evt.target.value);
  };
  return (
    <div className={styles.body}>
      <label htmlFor={id}>{header}</label>
      {type === "address" ? (
        <textarea
          className={error ? styles.input_error : styles.input}
          type={type}
          id={id}
          name={id}
          maxLength={maxLength}
          onChange={handleChange}
          required
        >
          {value}
        </textarea>
      ) : (
        <input
          className={error ? styles.input_error : styles.input}
          onChange={handleChange}
          type={type}
          id={id}
          name={id}
          maxLength={maxLength}
          value={value}
          required
        />
      )}
      <div className={styles.error}>{error}</div>
    </div>
  );
}

export default Forminput;
